export default async (base64string: string, fileName: string, fileType: string) =>
  await fetch(base64string)
    .then((res) => res.blob())
    .then((blob) => {
      return new File([blob], fileName, { type: fileType });
    });
